import { Component, OnInit } from '@angular/core';
import packageInfo from 'package.json';

@Component({
	selector: 'cmv-footer-one',
	templateUrl: './footer-one.component.html',
	styleUrls: ['./footer-one.component.scss'],
})
export class FooterOneComponent {
	public version: string = packageInfo.version;
	public updateAt: string = packageInfo.updateAt;
	constructor() {}
}
